import React from 'react';
import Module2Classification from '../components/Module2Classification';
import ErrorBoundary from '../components/ErrorBoundary';

// Error component to display when component encounters errors
const ErrorComponent = () => {
  return (
    <div className="p-6 bg-red-50 border border-red-200 rounded-md">
      <h2 className="text-xl font-bold text-red-600 mb-2">An error occurred</h2>
      <p className="text-gray-700">
        We're sorry, but something went wrong while loading Module 2 classification.
      </p>
      <button 
        onClick={() => window.location.href = '/'}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        Return to Dashboard
      </button>
    </div>
  );
};

const Module2ClassificationPage: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorComponent />}>
      <Module2Classification />
    </ErrorBoundary>
  );
};

export default Module2ClassificationPage;
